module.exports = __webpack_public_path__ + "img/3Dg.a1fd68c5.png";